import React from "react";
import "./article-tile.scss";

interface PlaceholderTileProps {
  slot: number;
}

const PlaceholderTile = ({ slot }: PlaceholderTileProps) => {
  return (
    <div className="article-tile placeholder-tile" data-testid={`placeholder-tile-${slot}`}>
      <div className="article-image placeholder-image"></div>
    </div>
  );
};

export default PlaceholderTile;
